import { PRODUCTION } from '@globals';

export function slugify(text) {
  if (!text) return '';
  const a = 'àáäâèéëêìíïîòóöôõȭȱȯōøūùúüûñçßÿœæŕśńṕẃǵǹḿǘẍźḧ·/_,:;';
  const b = 'aaaaeeeeiiiioooooooooouuuuuncsyoarsnpwgnmuxzh------';
  const p = new RegExp(a.split('').join('|'), 'g');

  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special chars
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w-]+/g, '') // Remove all non-word chars
    .replace(/--+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, ''); // Trim - from end of text
}

export function generateUUID() {
  // Public Domain/MIT
  var d = new Date().getTime();
  if (
    typeof performance !== 'undefined' &&
    typeof performance.now === 'function'
  ) {
    d += performance.now(); //use high-precision timer if available
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
export function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

export function getParams() {
  return window.location.search.substring(1)
    ? window.location.search
        .substring(1)
        .split('&')
        .reduce((params, str) => {
          params[decodeURIComponent(str.split('=')[0])] = decodeURIComponent(
            str.split('=')[1]
          );
          return params;
        }, {})
    : {};
}

export function getCookies() {
  return document.cookie.split(';').reduce((cookies, str) => {
    cookies[str.split('=')[0].trim()] = str.split('=')[1];
    return cookies;
  }, {});
}
export function deleteCookie(key, path, domain) {
  document.cookie =
    `${encodeURIComponent(key)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT` +
    (domain ? '; domain=' + domain : '') +
    (path ? '; path=' + path : '');
  if (getCookies()[key] && !path) {
    deleteCookie(key, '/');
  }
  if (getCookies()[key] && !path) {
    const possiblePaths = window.location.pathname
      .split('/')
      .map((item, index, array) => array.slice(0, index).join('/'))
      .filter(item => item);
    possiblePaths.forEach(path => deleteCookie(key, path));
  }

  return getCookies()[key];
}
const defaultPreferences = {
  date: new Date().toJSON().substring(0, 10),
  time: '19:00',
  persons: 2,
  period: 'dinner',
};

export function setPreferences({ date, time, persons, period }) {
  if (date) localStorage.setItem('TableOnline--date', date);
  if (time) localStorage.setItem('TableOnline--time', time);
  if (persons) localStorage.setItem('TableOnline--persons', persons);
  if (period) localStorage.setItem('TableOnline--period', period);
  return getPreferences();
}

export function getPreferences() {
  const queryPreferences = getParams();

  const date =
    queryPreferences.date || localStorage.getItem('TableOnline--date');
  const time =
    queryPreferences.time || localStorage.getItem('TableOnline--time');
  const persons =
    queryPreferences.persons || localStorage.getItem('TableOnline--persons');
  const period =
    queryPreferences.period || localStorage.getItem('TableOnline--period');

  const preferences = { ...defaultPreferences };
  if (
    date &&
    new Date(date).valueOf() >= new Date(defaultPreferences.date).valueOf()
  )
    preferences.date = date;
  if (time) preferences.time = time;
  if (persons) preferences.persons = parseInt(persons);
  if (period) preferences.period = period;

  return preferences;
}

const languages = [navigator.language, ...navigator.languages];

const defaultCity =
  languages.includes('et') ||
  languages.includes('et-EE') ||
  window.location.pathname.split('/')[1] === 'ee'
    ? 'Tallinn'
    : 'Helsinki';

export function setCity(city) {
  const capitalizedCity = city
    ? city[0].toUpperCase() + city.substring(1)
    : null;
  if (capitalizedCity)
    localStorage.setItem('TableOnline--city', capitalizedCity);
  return getCity();
}
export function getCity() {
  const city =
    localStorage && localStorage.getItem('TableOnline--city')
      ? localStorage.getItem('TableOnline--city')
      : defaultCity;
  const capitalizedCity = city[0].toUpperCase() + city.substring(1);
  return capitalizedCity;
}
export function setAffiliate(key, value) {
  const date = new Date();
  try {
    if (key === 'norwegian') {
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
      if (window.name === 'norwegianfetch') {
        window.close();
      }
    } else if (key === 'finnair') {
      date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
    } else if (key === 'tlink') {
      date.setTime(date.getTime() + 12 * 60 * 60 * 1000);
    }
    // Set cookie
    document.cookie = `TableOnline--affiliate=${key}:${value}; expires=${date.toUTCString()}; path=/`;
  } catch (err) {}

  return getAffiliate();
}
export function getAffiliate() {
  const affiliate = getCookies()['TableOnline--affiliate'];
  if (affiliate) {
    return { [affiliate.split(':')[0]]: affiliate.split(':')[1] };
  }
  return;
}
export function setInternalTrackingTag(key, value) {
  const valueToString = Array.isArray(value) ? value.join(',') : value;
  const date = new Date();
  if (!valueToString) return getInternalTrackingTag();
  try {
    if (key === 'tags') {
      date.setTime(date.getTime() + 12 * 60 * 60 * 1000);
    }
    const valueToString = Array.isArray(value) ? value.join(',') : value;
    // Set cookie
    document.cookie = `TableOnline--tags=${encodeURIComponent(
      valueToString
    )}; expires=${date.toUTCString()}; path=/`;
  } catch (err) {}

  return getInternalTrackingTag();
}
export function getInternalTrackingTag() {
  const internalTags = getCookies()['TableOnline--tags'];
  if (internalTags) {
    return decodeURIComponent(internalTags).split(',');
  }
  return [];
}
export function fixEmail(e) {
  let email = e.target ? e.target.value : e;

  const emailEndingFixDictionary = {
      '@gmail.co': '@gmail.com',
      '@gmail.fi': '@gmail.com',
      '@hotmail.co': '@hotmail.com',
      '.f': '.fi',
      '.fo': '.fi',
      '.cmo': '.com',
      '.ccom': '.com',
      '.comm': '.com',
      '.coom': '.com',
      '.col': '.com',
      '.con': '.com',
      '.gom': '.com',
      '.vom': '.com',
      '.xom': '.com',
    },
    emailInternalFixDictionary = {
      '@gmai.': '@gmail.',
      '@gmil.': '@gmail.',
      '@gamil.': '@gmail.',
      '@gnail.': '@gmail.',
      '@hotmai.': '@hotmail.',
    };

  Object.keys(emailEndingFixDictionary).forEach(function (mistake) {
    const fix = emailEndingFixDictionary[mistake];
    if (email.lastIndexOf(mistake) === email.length - mistake.length) {
      email = email.replace(mistake, fix);
    }
  });
  Object.keys(emailInternalFixDictionary).forEach(function (mistake) {
    const fix = emailInternalFixDictionary[mistake];
    if (email.indexOf(mistake)) {
      email = email.replace(mistake, fix);
    }
  });

  return email;
}

export function validEmail(email) {
  if (!email || typeof email !== 'string') return false;
  // Created because the clients sometimes forget TLD's and supporting
  // e.g. 'localhost' email domain is not necessary
  const supportedEmailExpression =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]{2,})$/g;
  return supportedEmailExpression.test(email);
}

export function findClosestDay(recurrencies, startDay) {
  if (
    !startDay ||
    new Date(startDay.substring(0, 10)).valueOf() <
      new Date(new Date().toJSON().substring(0, 10)).valueOf()
  ) {
    startDay = new Date();
  } else {
    startDay = new Date(startDay);
  }

  const todayWeekday = startDay.getDay(),
    distanceComparison = 7 - todayWeekday;

  const distanceToOfferWeekDay = recurrencies.reduce((closest, current) => {
    return closest === 0 || !current.week_day
      ? closest
      : closest
      ? Math.min(
          distanceComparison - ((7 - current.week_day) % 7),
          distanceComparison - ((7 - closest) % 7)
        )
      : distanceComparison - ((7 - current.week_day) % 7);
  }, null);

  const closestDay = startDay;

  if (distanceToOfferWeekDay) {
    closestDay.setDate(closestDay.getDate() + distanceToOfferWeekDay + 1);
  }
  return closestDay.toJSON().substring(0, 10);
}
export function buildRestaurantUrl(restaurant, lang) {
  if (!restaurant || !lang) {
    return '';
  }
  return `/${lang}/${slugify(restaurant.city)}/${restaurant.slug}/${
    restaurant.restaurantId
  }`;
}
export function parseImageUrl(url) {
  if (!url) {
    return '';
  }

  url = url.replace('https://tox.imgix.net/', '');
  url = url.replace(
    'https://images.weserv.nl/?url=https://tableonline.static.cm/',
    ''
  );

  //console.log(url);
  const imageBase = PRODUCTION
    ? 'https://img.tableonline.fi'
    : 'https://preprod-img.tableonline.fi';
  return url.indexOf('http') === 0 ? url : `${imageBase}/${url}`;
}
export function untilResponds(url) {
  return new Promise(resolve => {
    const poll = setInterval(async () => {
      try {
        const test = await fetch(`${url}?noCachePoll=${new Date().valueOf()}`);
        if (test.ok) {
          clearInterval(poll);
          resolve(true);
        }
      } catch (err) {}
    }, 2000);
  });
}
export function publishedDateFromObjectId(objectId) {
  return new Date(parseInt(objectId.substring(0, 8), 16) * 1000).toISOString();
}
export function distanceFromDate(date) {
  const compare = typeof date === 'string' ? new Date(date) : date;
  const isValid =
    typeof compare.getTime === 'function' &&
    compare.getTime() === compare.getTime();

  if (isValid) {
    const today = new Date();
    const distance = today - compare;
    const days = ~~(distance / 86400000);
    const months = ~~(days / 30);
    const years = ~~(months / 12);

    return {
      days,
      months,
      years,
    };
  }
  return null;
}
export function parseDateToReadable(date) {
  if (date === null) return '';
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  return dateObj
    .toJSON()
    .substring(0, 10)
    .split('-')
    .reverse()
    .map(item => parseInt(item))
    .join('.');
}

export function parseCommercialDateRange(start_date, end_date) {
  if (!start_date && !end_date) return null;

  const startDate = parseDateToReadable(start_date);
  const endDate = parseDateToReadable(end_date);
  const now = parseDateToReadable(new Date());

  if (startDate === endDate) {
    return startDate;
  } else if (endDate === null) {
    return `${now} - ${endDate}`;
  } else {
    return `${startDate} - ${endDate}`;
  }
}

export function sortCommercialsByDate(commercials = []) {
  return [...commercials].sort((a, b) => {
    const aPermanent = a.permanent || !a.end_date;
    const bPermanent = b.permanent || !b.end_date;
    if (aPermanent && bPermanent) return 0;
    if (aPermanent) return 1;
    if (bPermanent) return -1;

    const endDiff =
      new Date(a.end_date).valueOf() - new Date(b.end_date).valueOf();
    if (endDiff !== 0) return endDiff;

    const startA = a.start_date
      ? new Date(a.start_date).valueOf()
      : Infinity;
    const startB = b.start_date
      ? new Date(b.start_date).valueOf()
      : Infinity;
    return startA - startB;
  });
}



// WEBPACK FOOTER //
// ./helpers.js